import { ArrowRightLeft } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const MOVABLE_TYPES = { clienti: "Clienti", controparti: "Controparti", testimoni: "Testimoni" };

// Spostamento multiplo delle schede selezionate.
export function MoveAnagBulk({ ids, atype, onMoved, disabled }) {
  if (!MOVABLE_TYPES[atype]) return null;
  const move = async (to) => {
    if (!window.confirm(`Spostare ${ids.length} ${ids.length === 1 ? "scheda" : "schede"} da ${MOVABLE_TYPES[atype]} a ${MOVABLE_TYPES[to]}?\nI collegamenti alle pratiche restano invariati.`)) return;
    try {
      const { data } = await api.post(`/anagrafiche/${atype}/sposta-multiplo`, { ids, to });
      toast.success(`${data.moved} ${data.moved === 1 ? "scheda spostata" : "schede spostate"} in ${MOVABLE_TYPES[to]}`);
      if (data.blocked?.length) toast.warning(`${data.blocked.length} non ${data.blocked.length === 1 ? "spostata" : "spostate"} (accesso Area Riservata attivo): ${data.blocked.join(", ")}`, { duration: 8000 });
      onMoved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button disabled={disabled} data-testid="anag-bulk-move-btn" className="bg-teal-600 hover:bg-teal-700 text-white font-semibold"><ArrowRightLeft className="h-4 w-4 mr-1.5" /> Sposta selezionati</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="top">
        <DropdownMenuLabel className="text-xs">Sposta in…</DropdownMenuLabel>
        {Object.entries(MOVABLE_TYPES).filter(([k]) => k !== atype).map(([k, l]) => (
          <DropdownMenuItem key={k} onSelect={() => move(k)} data-testid={`anag-bulk-move-to-${k}`}>{l}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

// Sposta una scheda tra Clienti / Controparti / Testimoni mantenendo lo stesso id (i collegamenti alle pratiche restano).
export function MoveAnagCategory({ rec, atype, name, onMoved }) {
  if (!MOVABLE_TYPES[atype]) return null;
  const move = async (to) => {
    if (!window.confirm(`Spostare "${name}" da ${MOVABLE_TYPES[atype]} a ${MOVABLE_TYPES[to]}?\nI collegamenti alle pratiche restano invariati.`)) return;
    try {
      await api.post(`/anagrafiche/${atype}/${rec.id}/sposta`, { to });
      toast.success(`Spostato in ${MOVABLE_TYPES[to]}`);
      onMoved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="ghost" title="Sposta in un'altra categoria" data-testid={`anag-move-${rec.id}`} className="text-slate-400 hover:text-slate-100 hover:bg-slate-700/40"><ArrowRightLeft className="h-4 w-4" /></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="text-xs">Sposta in…</DropdownMenuLabel>
        {Object.entries(MOVABLE_TYPES).filter(([k]) => k !== atype).map(([k, l]) => (
          <DropdownMenuItem key={k} onSelect={() => move(k)} data-testid={`anag-move-${rec.id}-to-${k}`}>{l}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
